(function () {
  var STYLE_ID = 'size-variant-jerk-style';
  var ACTIVE_CLASS = 'is-size-variant-jerking';
  var JERK_DURATION = 450;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '@keyframes sizeVariantJerk {',
      '  0% { transform: translate3d(0, 0, 0); }',
      '  18% { transform: translate3d(-10px, 0, 0); }',
      '  36% { transform: translate3d(9px, 0, 0); }',
      '  54% { transform: translate3d(-7px, 0, 0); }',
      '  72% { transform: translate3d(5px, 0, 0); }',
      '  100% { transform: translate3d(0, 0, 0); }',
      '}',
      '.template-product .' + ACTIVE_CLASS + ' {',
      '  animation: sizeVariantJerk 420ms cubic-bezier(.36,.07,.19,.97);',
      '  transform-origin: center;',
      '}',
      '.template-product .' + ACTIVE_CLASS + ' .selected-size-box,',
      '.template-product .' + ACTIVE_CLASS + '.product-form__input,',
      '.template-product .' + ACTIVE_CLASS + ' fieldset.product-form__input {',
      ' ',
      '}'
    ].join('');

    document.head.appendChild(style);
  }

  function getScrollOffset() {
  var mobileOffset = 110;
  var desktopOffset = 32;
  var fallbackOffset = window.innerWidth < 750 ? mobileOffset : desktopOffset;
  var selectors = [
    '.shopify-section-group-header-group',
    'sticky-header',
    '.header-wrapper',
    '.header',
    '.shopify-section-header-sticky'
  ];
  var maxBottom = 0;

  selectors.forEach(function (selector) {
    var element = document.querySelector(selector);
    if (!element) return;

    var style = window.getComputedStyle(element);
    var isTopPinned = style.position === 'fixed' || style.position === 'sticky';
    if (!isTopPinned) return;

    var rect = element.getBoundingClientRect();
    if (rect.bottom > 0) {
      maxBottom = Math.max(maxBottom, rect.bottom);
    }
  });

  return Math.max(fallbackOffset, Math.round(maxBottom) + 16);
}

function easeInOutCubic(progress) {
  return progress < 0.5
    ? 4 * progress * progress * progress
    : 1 - Math.pow(-2 * progress + 2, 3) / 2;
}

function smoothScrollToY(targetY) {
  if (typeof window.requestAnimationFrame !== 'function') {
    window.scrollTo(0, targetY);
    return Promise.resolve();
  }

  var startY = window.pageYOffset || window.scrollY || 0;
  var distance = targetY - startY;

  if (Math.abs(distance) < 4) {
    window.scrollTo(0, targetY);
    return Promise.resolve();
  }

  var duration = Math.max(250, Math.min(700, Math.abs(distance) * 0.6));

  return new Promise(function (resolve) {
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;

      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var easedProgress = easeInOutCubic(progress);

      window.scrollTo(0, startY + distance * easedProgress);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        window.scrollTo(0, targetY);
        resolve();
      }
    }

    window.requestAnimationFrame(step);
  });
}

function scrollTargetIntoView(element) {
  if (!element) return Promise.resolve();

  var rect = element.getBoundingClientRect();
  var targetY = Math.max(
    0,
    rect.top + (window.pageYOffset || window.scrollY || 0) - getScrollOffset()
  );

  return smoothScrollToY(targetY);
}

function startJerkAnimation(target) {
  if (!target) return;

  target.classList.remove(ACTIVE_CLASS);
  void target.offsetWidth;
  target.classList.add(ACTIVE_CLASS);

  window.clearTimeout(target._sizeVariantJerkTimer);
  target._sizeVariantJerkTimer = window.setTimeout(function () {
    target.classList.remove(ACTIVE_CLASS);
  }, JERK_DURATION);
}


  function getSizeFieldset(scope) {
    var fieldsets = Array.from(
      (scope || document).querySelectorAll('.other-opt-container .product-form__input, fieldset.product-form__input')
    );

    return fieldsets.find(function (fieldset) {
      var label = fieldset.querySelector('.form__label');
      var labelText = label ? label.textContent.trim().toLowerCase() : '';
      return labelText.indexOf('size') !== -1;
    }) || null;
  }

  function getColorFieldset(scope) {
    var fieldsets = Array.from(
      (scope || document).querySelectorAll('fieldset.product-form__input')
    );

    return fieldsets.find(function (fieldset) {
      var label = fieldset.querySelector('.form__label');
      var labelText = label ? label.textContent.trim().toLowerCase() : '';
      return labelText.indexOf('color') !== -1 || labelText.indexOf('colour') !== -1;
    }) || null;
  }

  function getSelectedSizeInput(sizeFieldset) {
    if (!sizeFieldset) return null;
    return sizeFieldset.querySelector('input[type="radio"]:checked, select');
  }

  function getSelectedColorInput(colorFieldset) {
    if (!colorFieldset) return null;
    return colorFieldset.querySelector('input[type="radio"]:checked');
  }

  function getJerkTarget(fieldset) {
    if (!fieldset) return null;
    return fieldset.closest('.other-opt-container') || fieldset.closest('.product-swatch-options') || fieldset;
  }

  // function runJerk(sizeFieldset) {
  //   console.log(sizeFieldset, "sizeFieldset");
  //   var target = getJerkTarget(sizeFieldset);
  //   console.log(target, "target");
  //   if (!target) return;

  //   target.classList.remove(ACTIVE_CLASS);
  //   void target.offsetWidth;
  //   target.classList.add(ACTIVE_CLASS);

  //   var selectedSizeBox = target.querySelector('.selected-size-box');
  //   if (selectedSizeBox && window.innerWidth < 750) {
  //     var dropdown = target.querySelector('.opt-dropdown');
  //     if (dropdown) dropdown.classList.add('active');
  //   }

  //   if (selectedSizeBox && typeof selectedSizeBox.scrollIntoView === 'function') {
  //     selectedSizeBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //   } else if (typeof target.scrollIntoView === 'function') {
  //     target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //   }

  //   window.clearTimeout(target._sizeVariantJerkTimer);
  //   target._sizeVariantJerkTimer = window.setTimeout(function () {
  //     target.classList.remove(ACTIVE_CLASS);
  //   }, 450);
  // }

  function runJerk(sizeFieldset) {
  console.log(sizeFieldset, "sizeFieldset");
  var target = getJerkTarget(sizeFieldset);
  console.log(target, "target");
  if (!target) return;

  var selectedSizeBox = target.querySelector('.selected-size-box');
  if (selectedSizeBox && window.innerWidth < 750) {
    var dropdown = target.querySelector('.opt-dropdown');
    if (dropdown) dropdown.classList.add('active');
  }

  window.clearTimeout(target._sizeVariantScrollTimer);
  target._sizeVariantScrollTimer = window.setTimeout(function () {
    scrollTargetIntoView(selectedSizeBox || target).then(function () {
      startJerkAnimation(target);
    });
  }, 30);
}


  function triggerSizeVariantJerk(scope) {
    var sizeFieldset = getSizeFieldset(scope || document);
    if (!sizeFieldset) return false;

    runJerk(sizeFieldset);
    return true;
  }

  function getUnselectedFieldset(rootSection) {
    var colorFieldset = getColorFieldset(rootSection);
    if (colorFieldset && !getSelectedColorInput(colorFieldset)) return colorFieldset;
    var sizeFieldset = getSizeFieldset(rootSection);
    if (sizeFieldset && !getSelectedSizeInput(sizeFieldset)) return sizeFieldset;
    return null;
  }

  function isCurrentVariantUnavailable(rootSection) {
    var form = rootSection.querySelector('form[action*="/cart/add"]');
    if (!form) return false;
    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return false;
    var variantId = variantInput.value;
    var jsonScript = rootSection.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (!jsonScript) return false;
    try {
      var variants = JSON.parse(jsonScript.textContent || '[]');
      var match = variants.find(function (v) { return String(v.id) === String(variantId); });
      return match ? !match.available : false;
    } catch (e) {
      return false;
    }
  }

  function handleButtonClick(event) {
    var button = event.target.closest('button[name="add"].product-form__submit, [data-sticky-submit], [data-modal-submit], .custom-static-btn.oos_static_btn.product-form__submit, [data-pdp-buy-now]');

    if (!button) return;
    if (button.hasAttribute('data-sticky-submit') || button.hasAttribute('data-modal-submit')) return;
    var rootSection = button.closest('.shopify-section, section, main, .template-product') || document;

    var targetFieldset = getUnselectedFieldset(rootSection);
    if (targetFieldset) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      runJerk(targetFieldset);
      return;
    }

    if (isCurrentVariantUnavailable(rootSection) || button.classList.contains('variant-oos')) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      var sizeFieldset = getSizeFieldset(rootSection);
      if (sizeFieldset) {
        runJerk(sizeFieldset);
      }
      return;
    }
  }

  function handleFormSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"], .product-form form')) {
      return;
    }
    if (form.closest('custom-sticky-add-to-cart')) return;

    var rootSection = form.closest('.shopify-section, section, main, .template-product') || document;
    var targetFieldset = getUnselectedFieldset(rootSection);
    if (!targetFieldset) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    runJerk(targetFieldset);
  }

  // function handleOOSClick(event) {
  //   // event.preventDefault();
  //   var button = event.target.closest('.product-form__submit.oos_static_btn.btn-visible');
  //   if (!button) return;
  //   var rootSection = button.closest('.shopify-section, section, main, .template-product') || document;
  //   var sizeFieldset = getSizeFieldset(rootSection);
  //   // if (!sizeFieldset) return;
  //   runJerk(sizeFieldset);
  // }

  function handleOOSClick(event) {
    var button = event.target.closest('.product-form__submit.oos_static_btn.btn-visible');
    if (!button) return;
    event.preventDefault();
    var rootSection = button.closest('.shopify-section, section, main, .template-product') || document;
    var targetFieldset = getUnselectedFieldset(rootSection);
    if (!targetFieldset) {
      targetFieldset = getSizeFieldset(rootSection) || getColorFieldset(rootSection);
    }
    if (targetFieldset) runJerk(targetFieldset);
  }

  function init() {
    if (!document.body || document.body.dataset.sizeVariantJerkReady === 'true') return;

    injectStyles();
    document.body.dataset.sizeVariantJerkReady = 'true';
    window.triggerSizeVariantJerk = triggerSizeVariantJerk;
    document.addEventListener('click', handleButtonClick, true);
    document.addEventListener('submit', handleFormSubmit, true);
    document.addEventListener('click', handleOOSClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
